import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, ShieldOff } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-8 px-4 sm:px-6 lg:px-8 bg-zinc-950 relative overflow-hidden" data-id="element-142">
      {/* Subtle texture */}
      <div className="absolute inset-0 opacity-5 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] pointer-events-none" data-id="element-143" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-144">
        <div className="text-center mb-6" data-id="element-145">
          <h2 className="text-2xl md:text-3xl font-serif text-white mb-1 leading-[1.05]" data-id="element-146">
            La trampa que está destruyendo tu intimidad
          </h2>
          <p className="text-zinc-400 text-base leading-[1.2]" data-id="element-147">
            La mayoría hace una de dos cosas, y ambas empeoran el clima.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-4 mb-6" data-id="element-148">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-zinc-900/50 p-4 rounded-lg border border-zinc-800 hover:border-red-900/30 transition-colors" data-id="element-149">
            <div className="flex items-center gap-2 mb-1 text-red-400" data-id="element-150">
              <AlertCircle className="w-5 h-5" data-id="element-151" />
              <h3 className="text-base font-serif" data-id="element-152">La Persecución</h3>
            </div>
            <p className="text-zinc-400 mb-1 text-sm leading-[1.2]" data-id="element-153">
              Pides cariño, pides explicación, pides "hablar".
            </p>
            <p className="text-zinc-300 font-medium text-sm leading-[1.2]" data-id="element-154">
              Resultado: La otra persona se defiende y se aleja más.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-zinc-900/50 p-4 rounded-lg border border-zinc-800 hover:border-blue-900/30 transition-colors" data-id="element-155">
            <div className="flex items-center gap-2 mb-1 text-blue-400" data-id="element-156">
              <ShieldOff className="w-5 h-5" data-id="element-157" />
              <h3 className="text-base font-serif" data-id="element-158">El Retiro</h3>
            </div>
            <p className="text-zinc-400 mb-1 text-sm leading-[1.2]" data-id="element-159">
              Te enfrías, castigas con silencio, te haces el fuerte.
            </p>
            <p className="text-zinc-300 font-medium text-sm leading-[1.2]" data-id="element-160">
              Resultado: La relación se vuelve de "roommates".
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-zinc-900 p-5 rounded-xl text-center border border-zinc-800" data-id="element-161">
          <h3 className="text-lg font-serif text-white mb-2 leading-[1.05]" data-id="element-162">
            Por eso "tenemos que hablar" casi siempre falla
          </h3>
          <p className="text-zinc-400 mb-3 max-w-2xl mx-auto text-sm leading-[1.2]" data-id="element-163">
            No es mala intención. Es biología emocional. Esa frase suena a
            juicio, examen y deuda. En una relación fría, no hay energía para
            "otra conversación".
          </p>
          <p className="text-base text-[#d4a574] font-serif italic leading-[1.15]" data-id="element-164">
            Lo que sí puede tolerar… es una rendija. Algo pequeño. Seguro. Sin
            presión.
          </p>
        </motion.div>
      </div>
    </section>;
}